import { ProdEnvironment } from "./prod.env";
import { DevEnvironment } from "./dev.env";
import { StageEnvironment } from "./staging.env";
import { DemoEnvironment } from "./demo.env";

export interface Environment {
  base_url: string;
  temp_base_url: string;
}

export function getEnvVariable() {
  switch (process.env.REACT_APP_NODE_ENV) {
    case "production":
      return ProdEnvironment;
    case "test":
      return StageEnvironment;
    case "staging":
      return StageEnvironment;
    case "demo":
      return DemoEnvironment;
    default:
      return DevEnvironment;
  }
}
